<template>
  <div id="accountDrawer" class="fixed inset-0 h-[100dvh] z-[999999] isolate overflow-hidden">
    <div
      class="backdrop accountDrawer-transition bg-[#21375699]/80 text-[#253754] absolute inset-0"
      @click="handleCloseSelf"
    ></div>
    <div class="relative paper accountDrawer-transition bg-[#F7F7F7] flex flex-col h-full w-96 ml-auto overflow-auto">
      <div class="shrink-0 sticky top-0 z-10 bg-inherit py-4 px-6 flex flex-row gap-2 items-center border-b">
        <NuxtImg
          loading="lazy"
          :src="`/icons/${!userSession?.loggedIn || !isHomeTestEnabled ? 'user-logged' : 'profile'}.svg`"
          :alt="$t('pages.account.drawer.patient_login_alt')"
          width="27"
          height="25"
          class="shrink-0 w-7 h-7"
        />
        <BaseTypography variant="span" class="font-semibold px-2">
          {{ headerTitle }}
        </BaseTypography>

        <button
          @click="handleCloseSelf"
          type="button"
          class="ml-auto z-50 text-gray-400 bg-light-silver rounded-full fill-secondary p-1"
        >
          <svg aria-hidden="true" class="w-5 h-5" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="sr-only">{{ $t("pages.account.drawer.close_modal") }}</span>
        </button>
      </div>

      <div class="shrink-0 flex-grow">
        <AccountDrawerGuestContent v-if="!userSession?.loggedIn" />
        <AccountDrawerLoggedContent v-else />
      </div>
      <div class="shrink-0 sticky bottom-0 z-10 bg-inherit py-4 px-6 border-t">
        <button class="text-secondary font-bold underline" @click="handleCloseSelf">{{ $t("common.cancel") }}</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute();
const { t } = useI18n();

const profileStore = useProfileStore();
await profileStore.fetchProfile();

const globalStore = useGlobalStore();
const { isHomeTestEnabled } = storeToRefs(globalStore);

const userSession = ref();
userSession.value = {
  loggedIn: profileStore.loggedIn,
  profile: profileStore.profile,
};

//console.log('#####################Drawer.vue called############')
// console.log(userSession.value.loggedIn)
// console.log(userSession.value.profile)

const headerTitle = computed(() => {
  const session = userSession.value;

  if (!session) return "U/N";

  if (!session.loggedIn || !isHomeTestEnabled.value) return t("pages.account.drawer.header_your_results");

  if (!session.profile) return t("pages.account.drawer.header_my_account");

  const { first_name, last_name } = session.profile;
  return `${first_name} ${last_name}`;
});

function handleCloseSelf() {
  const trigger = document.querySelector<HTMLInputElement>("#accountDrawerTrigger");
  if (!trigger) return;

  trigger.checked = false;
}

const bus = useNuxtApp().$bus as any;

bus.on("user-logged-in", () => {
  setTimeout(async () => {
    await profileStore.fetchProfile();
    userSession.value = {
      loggedIn: true,
      profile: profileStore.profile,
    };

    //console.log('user-logged-in-event')
    //console.log(userSession.value.loggedIn)
    //console.log(userSession.value.profile)
  }, 1000);
});

bus.on("user-logged-out", () => {
  profileStore.resetState();

  userSession.value = {
    loggedIn: false,
    profile: null,
  };
});

watch(() => route.fullPath, handleCloseSelf);
</script>

<style scoped lang="scss">
.accountDrawer-transition {
  transition-duration: 500ms;
  transition-property: transform opacity;
}
</style>

<style lang="scss">
#accountDrawer {
  @apply pointer-events-none;

  .paper {
    @apply translate-x-full;
  }

  .backdrop {
    @apply opacity-0;
  }
}

body:has(#accountDrawerTrigger:checked) {
  @apply overflow-hidden;

  #accountDrawer {
    @apply pointer-events-auto;

    .paper {
      @apply translate-x-0;
    }

    .backdrop {
      @apply opacity-100;
    }
  }
}
</style>
